"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import posthog from "posthog-js";
import { sanitizeExtensionAuthEvent } from "@/lib/extension-auth-measurement";

export const PostHog = () => {
    const pathname = usePathname()

  useEffect(() => {
    // Only initialize PostHog in production
    if (process.env.NODE_ENV !== "development") {
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
        api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
        ui_host: "https://us.posthog.com",
        loaded: () => {
          if (process.env.NODE_ENV === "development") posthog.debug();
        },
        debug: false,
        before_send: sanitizeExtensionAuthEvent,
      });

      window.posthog = posthog;

      // Capture UTM parameters and referral info
      const captureUTMParams = () => {
        const searchParams = new URLSearchParams(window.location.search);
        const utmParams = {
          utm_source: searchParams.get('utm_source'),
          utm_medium: searchParams.get('utm_medium'),
          utm_campaign: searchParams.get('utm_campaign'),
          utm_content: searchParams.get('utm_content'),
          utm_term: searchParams.get('utm_term'),
          referrer: document.referrer,
          referrer_domain: document.referrer ? new URL(document.referrer).hostname : 'direct',
          landing_page: window.location.pathname,
        };

        // Register as super properties (persist across all events)
        if (Object.values(utmParams).some(v => v)) {
          posthog.register(utmParams);
        }
      };

      captureUTMParams();
    }
  }, []);

  useEffect(() => {
    // Only capture pageviews in production
    if (process.env.NODE_ENV !== "development") {
      const searchParams = new URLSearchParams(window.location.search);
      posthog.capture("$pageview", {
        $current_url: window.location.href,
        $pathname: pathname,
        utm_source: searchParams.get('utm_source'),
        utm_medium: searchParams.get('utm_medium'),
        utm_campaign: searchParams.get('utm_campaign'),
        utm_content: searchParams.get('utm_content'),
        utm_term: searchParams.get('utm_term'),
      });
    }
  }, [pathname]);

  return null;
};
